// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2BjYA","info":"UpdateTermsInfo_info__3rY8w"};